/**
 * Limites de caracteres dos campos de Observação (e similares) da aplicação.
 *
 * ===========================================================================
 *  PONTO ÚNICO DE ALTERAÇÃO
 *  Para mudar o limite de qualquer campo de Observação, altere o valor aqui.
 *  Não usar números "mágicos" (maxlength="900") espalhados nos templates/models.
 * ===========================================================================
 *
 * RN01: o limite deve refletir o tamanho da coluna no banco de dados.
 * Valor atual confirmado pelo time: 900 caracteres.
 */
export const LIMITES_CARACTERES = {
  /** Limite padrão dos campos de Observação do SPA. */
  OBSERVACAO: 900,
} as const;